import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {ProductDetailsRoutingModule} from './product-details-routing.module';
import {ProductDetailsComponent} from './product-details/product-details.component';
import {ThumbnailsComponent} from './product-image/thumbnails/thumbnails.component';
import {ProductBasicInfoComponent} from './product-details-info/product-basic-info/product-basic-info.component';
import {ProductImageComponent} from './product-image/product-image/product-image.component';
import {ProductBigImageComponent} from './product-image/product-big-image/product-big-image.component';
import {
	BulkLoginAndShareAndAddtostoryboardContainerComponent
} from './product-details-info/bulk-login-and-share-and-addtostoryboard-container/bulk-login-and-share-and-addtostoryboard-container.component';
import {ComponentsLibraryModule} from '../components-library/components-library.module';
import {ChooseColorComponent} from './product-details-info/choose-color/choose-color.component';
import {ChooseFabricComponent} from './product-details-info/choose-fabric-section/choose-fabric/choose-fabric.component';
import {
	ChooseFabricMoreOptionComponent
} from './product-details-info/choose-fabric-section/choose-fabric-more-option/choose-fabric-more-option.component';
import {ChooseSizeComponent} from './product-details-info/choose-size-options/choose-size/choose-size.component';
import {ChooseSizeMoreOptionComponent} from './product-details-info/choose-size-options/choose-size-more-option/choose-size-more-option.component';
import {ChooseCustomSizeComponent} from './product-details-info/choose-size-options/choose-custom-size/choose-custom-size.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {
	ChoseFabricMoreOptionInfoComponent
} from './product-details-info/choose-fabric-section/chose-fabric-more-option-info/chose-fabric-more-option-info.component';
import {OrderQuantityComponent} from './product-details-info/order-quantity/order-quantity/order-quantity.component';
import {CartButtonsComponent} from './product-details-info/cart-buttons/cart-buttons.component';
import {SelectMoreFinishComponent} from './product-details-info/select-finish/more-finish/select-more-finish.component';
import {SelectFinishComponent} from './product-details-info/select-finish/choose-select-finish/select-finish.component';
import {VolumeDiscountComponent} from './product-details-info/volume-discount/volume-discount.component';
import {BadgeProfileComponent} from './product-details-info/badge-profile/badge-profile.component';
import {ProductAccordionComponent} from './product-details-info/product-accordion/product-accordion.component';
import {TestimonialModule} from '../testimonial/testimonial.module';
import {PipeModule} from '../pipe/pipe.module';
import {QuantityCalculationService} from './service/quantity-calculation.service';
import {GsmAndWeightComponent} from './product-details-info/gsm-and-weight/gsm-and-weight.component';
import {ProductImageMobileComponent} from './product-image-mobile/product-image-mobile.component';
import {CarouselModule} from 'ngx-owl-carousel-o';
import {
	ChooseMoreFabricFinishOuterComponent
} from './product-details-info/choose-fabric-section/choose-more-fabric-finish-outer/choose-more-fabric-finish-outer.component';
import {PreOrderComponent} from './product-details-info/pre-order/pre-order/pre-order.component';
import {ContentSliderComponent} from './content-slider/content-slider.component';
import {ProductContentSliderLightComponent} from './content-slider/product-content-slider-light/product-content-slider-light.component';
import {ProductContentSliderDarkComponent} from './content-slider/product-content-slider-dark/product-content-slider-dark.component';
import {PreOrderPriceComponent} from './product-details-info/pre-order/pre-order-price/pre-order-price.component';
import {MoreFinishInfoComponent} from './product-details-info/select-finish/more-finish-info/more-finish-info.component';
import {
	ChooseMtoFabricMoreOptionInfoComponent
} from './product-details-info/choose-fabric-section/choose-mto-fabric-more-option-info/choose-mto-fabric-more-option-info.component';
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import {ReviewModule} from "../review/review.module";
import {DirectiveModule} from "../directive/directive.module";
import { OutOfStockNotifyDialogComponent } from './product-details-info/out-of-stock-notify-dialog/out-of-stock-notify-dialog.component';
import {BmxZoomifyModule} from "bmx-zoomify";


@NgModule({
	declarations: [
		ProductDetailsComponent,
		ThumbnailsComponent,
		ProductBasicInfoComponent,
		ProductImageComponent,
		ProductBigImageComponent,
		BulkLoginAndShareAndAddtostoryboardContainerComponent,
		ChooseColorComponent,
		ChooseFabricComponent,
		ChooseFabricMoreOptionComponent,
		ChooseSizeComponent,
		ChooseSizeMoreOptionComponent,
		ChooseCustomSizeComponent,
		ChoseFabricMoreOptionInfoComponent,
		OrderQuantityComponent,
		CartButtonsComponent,
		SelectMoreFinishComponent,
		SelectFinishComponent,
		VolumeDiscountComponent,
		BadgeProfileComponent,
		ProductAccordionComponent,
		GsmAndWeightComponent,
		ProductImageMobileComponent,
		ChooseMoreFabricFinishOuterComponent,
		PreOrderComponent,
		ContentSliderComponent,
		ProductContentSliderLightComponent,
		ProductContentSliderDarkComponent,
		PreOrderPriceComponent,
		MoreFinishInfoComponent,
		ChooseMtoFabricMoreOptionInfoComponent,
  OutOfStockNotifyDialogComponent,
	],
    imports: [
        CommonModule,
        ComponentsLibraryModule,
        ProductDetailsRoutingModule,
        FormsModule,
        TestimonialModule,
        ReactiveFormsModule,
        PipeModule,
        CarouselModule,
        MatProgressSpinnerModule,
        ReviewModule,
        DirectiveModule,
        BmxZoomifyModule
    ],
	exports: [],
	providers: [
		QuantityCalculationService
	]
})
export class ProductDetailsModule {
}
